





















import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import ZenyaDialog, { IZenyaDialog } from "@/components/dialogs/ZenyaDialog.vue";
import ApproveReview from "@/components/modules/document/ApproveReview.vue";
import { DocumentReviewer } from "@/types/document/documentReviewer";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import storeHelper from "@/store/store-helper";
import { DocumentVersionState } from "@/enums";
export default Vue.extend({
    name: "ApproveDocumentReviewAction",
    components: { DocumentToolbarAction, ZenyaDialog, ApproveReview },
    props: {
        reviewer: Object as () => DocumentReviewer,
        documentProperties: Object as () => DocumentVersionInfo,
        enable: Boolean,
        isButton: Boolean
    },
    data: function () {
        return {
            showApproveReviewDialog: false,
            showSavePendingChangesDialog: false
        };
    },
    watch: {
        showApproveReviewDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showApproveReviewDialog);
        }
    },
    methods: {
        isReviewDocument(): boolean {
            return this.documentProperties && this.documentProperties.state == DocumentVersionState.Review;
        },
        goToTasks(): void {
            this.$router.push({ name: "Tasks" });
        },
        approveClicked(): void {
            if (
                this.documentProperties &&
                this.documentProperties.state == DocumentVersionState.Review &&
                storeHelper.pendingDocumentCommentStore.hasPendingItems(this.documentProperties.document_id)
            ) {
                (this.$refs.zenyadialog as Vue & IZenyaDialog)
                    .open(this.$t("document.review.pendingChangesDialog.dialogTitle"), this.$t("document.review.pendingChangesDialog.message"))
                    .then(confirmed => {
                        if (!confirmed) return;
                        storeHelper.pendingDocumentCommentStore.savePendingItems(this.documentProperties.document_id);
                        this.showApproveReviewDialog = true;
                    });
            } else this.showApproveReviewDialog = true;
        }
    }
});
